export const FadeInSAL = {
  "data-aos": "fade",
}
